var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 19,
    viewBox: "0 0 41 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.775 4.03437e-05C29.315 4.03437e-05 26.9917 0.988885 25.3346 2.70171L13.325 13.7203C12.2317 14.8504 10.7796 15.4684 9.225 15.4684C6.03042 15.4684 3.41667 12.8021 3.41667 9.50002C3.41667 6.19798 6.03042 3.53163 9.225 3.53163C10.7796 3.53163 12.2317 4.14966 13.3933 5.3504L15.3238 7.1162L17.9375 4.75003L15.7508 2.79C14.8953 1.90238 13.8782 1.19881 12.7581 0.719939C11.6379 0.241065 10.4371 -0.0036143 9.225 4.03437e-05C4.13417 4.03437e-05 0 4.27327 0 9.50002C0 14.7268 4.13417 19 9.225 19C11.685 19 14.0083 18.0112 15.6654 16.2983L27.675 5.27977C28.7683 4.14966 30.2204 3.53163 31.775 3.53163C34.9696 3.53163 37.5833 6.19798 37.5833 9.50002C37.5833 12.8021 34.9696 15.4684 31.775 15.4684C30.2375 15.4684 28.7683 14.8504 27.6067 13.6496L25.625 11.8662L23.0625 14.2324L25.2492 16.21C26.107 17.0932 27.125 17.7927 28.2448 18.2684C29.3646 18.7442 30.5643 18.9868 31.775 18.9823C36.8658 18.9823 41 14.7268 41 9.50002C41 4.20263 36.8658 4.03437e-05 31.775 4.03437e-05Z",
    fill: "#02E4C0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.b98655c801415ea9b6a9749fd0caa521.svg";
export { ForwardRef as ReactComponent };